<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="keyword" placeholder="请输入账号/公司名称" clearable @clear="search" />
      </el-form-item>
      <el-form-item>
        <el-select v-model="dictValue" placeholder="请选择免显类型" clearable @clear="search">
          <el-option label="普通展示" value="card"></el-option>
          <el-option label="99年+推荐+套餐详情" value="cardNoShow"></el-option>
          <el-option label="5年+推荐+套餐详情" value="cardShowFive"></el-option>
          <el-option label="99年+VIP专线+套餐详情" value="cardSpecialShow"></el-option>
          <el-option label="免充流量套餐(免显弹窗)" value="noPayShow"></el-option>
          <el-option label="十年流量套餐包(免显弹窗)" value="noPay10Show"></el-option>
          <el-option label="五年流量套餐包(免显弹窗)" value="noPay5Show"></el-option>
          <el-option label="畅享+推荐+套餐详情" value="cardShow"></el-option>
          <el-option label="使用中+VIP专线+套餐详情" value="cardAgentShow"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search" >搜索</el-button>
        <el-button  size="medium" @click="resetForm">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click="adds">新增</el-button>
      </el-form-item>
    </el-form>
    
    <el-table v-loading="loading" border :data="tableData" row-key="id" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column type="index" align="center" />
      <el-table-column label="代理商名称" prop="companyName" min-width="160" :show-overflow-tooltip="true" />
      <el-table-column label="代理商层级" prop="companyPath" min-width="160" align="center" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column label="免显类型" prop="dictValue" min-width="160" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.dictValue =='card'">普通展示</span>
          <!-- 99年免显 -->
          <span v-if="scope.row.dictValue =='cardNoShow'">99年+推荐+套餐详情</span>
          <!-- 5年免显 -->
          <span v-if="scope.row.dictValue =='cardShowFive'">5年+推荐+套餐详情</span>
          <!-- 99年免显(不拥堵 不限量 不限速) -->
          <span v-if="scope.row.dictValue =='cardSpecialShow'">99年+VIP专线+套餐详情</span>
          <span v-if="scope.row.dictValue =='noPayShow'">免充流量套餐(免显弹窗)</span>
          <span v-if="scope.row.dictValue =='noPay10Show'">十年流量套餐包(免显弹窗)</span>
          <span v-if="scope.row.dictValue =='noPay5Show'">五年流量套餐包(免显弹窗)</span>
          <!-- 畅享状态展示 -->
          <span v-if="scope.row.dictValue =='cardShow'">畅享+推荐+套餐详情</span>
          <span v-if="scope.row.dictValue =='cardAgentShow'">使用中+VIP专线+套餐详情</span>
        </template>
      </el-table-column>
      <el-table-column label="作用范围" prop="level" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
          <span v-if="scope.row.level =='1'">当前账号</span>
          <span v-if="scope.row.level =='2'">当前账号及下级</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="createUser" min-width="100" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="创建时间" prop="createTime" min-width="120" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="操作" align="center" min-width="70" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="text" icon="el-icon-eidt" v-hasPermi="['agent:dict:edit']" @click="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="text" icon="el-icon-circle-close" v-hasPermi="['agent:dict:del']" @click="del(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" :visible.sync="dialog" :lock-scroll="false" width="700px" append-to-body v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" ref="form" :rules="rules">
        <el-form-item label="代理商名称:" prop="userId" label-width="100px">
          <el-select :disabled="!!form.id" v-model="form.userId" filterable placeholder="请选择代理商" clearable style="width:90%">
            <el-option v-for="(item,index) in agentData" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="免显类型:" prop="dictValue" label-width="100px">
          <el-select v-model="form.dictValue" :filterable="true" placeholder="请选择免显类型" style="width:90%" >
              <el-option label="普通展示" value="card"></el-option>
              <el-option label="99年+推荐+套餐详情" value="cardNoShow"></el-option>
              <el-option label="5年+推荐+套餐详情" value="cardShowFive"></el-option>
              <el-option label="99年+VIP专线+套餐详情" value="cardSpecialShow"></el-option>
              <el-option label="免充流量套餐(免显弹窗)" value="noPayShow"></el-option>
              <el-option label="十年流量套餐包(免显弹窗)" value="noPay10Show"></el-option>
              <el-option label="五年流量套餐包(免显弹窗)" value="noPay5Show"></el-option>
              <el-option label="畅享+推荐+套餐详情" value="cardShow"></el-option>
              <el-option label="使用中+VIP专线+套餐详情" value="cardAgentShow"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item  label-width="100px" v-if="form.dictValue == 'cardNoShow'">
          <el-image 
            style="width: 100px; height: 200px"
            :src="require('@/assets/img/dict/cardNoShow.png')" 
            :preview-src-list="[require('@/assets/img/dict/cardNoShow.png')]">
          </el-image>
        </el-form-item>
        <el-form-item  label-width="100px" v-if="form.dictValue == 'cardShowFive'">
          <el-image 
            style="width: 100px; height: 200px"
            :src="require('@/assets/img/dict/cardShowFive.png')" 
            :preview-src-list="[require('@/assets/img/dict/cardShowFive.png')]">
          </el-image>
        </el-form-item>
        <el-form-item  label-width="100px" v-if="form.dictValue == 'cardSpecialShow'">
          <el-image 
            style="width: 100px; height: 200px"
            :src="require('@/assets/img/dict/cardSpecialShow.png')" 
            :preview-src-list="[require('@/assets/img/dict/cardSpecialShow.png')]">
          </el-image>
        </el-form-item>
        <el-form-item  label-width="100px" v-if="form.dictValue == 'cardShow'">
          <el-image 
            style="width: 100px; height: 200px"
            :src="require('@/assets/img/dict/show.png')" 
            :preview-src-list="[require('@/assets/img/dict/show.png')]">
          </el-image>
        </el-form-item>
        <el-form-item  label-width="100px" v-if="form.dictValue == 'noPay10Show'">
          <el-image 
            style="width: 100px; height: 200px"
            :src="require('@/assets/img/dict/noPay10Show.png')" 
            :preview-src-list="[require('@/assets/img/dict/noPay10Show.png')]">
          </el-image>
        </el-form-item>
        <el-form-item  label-width="100px" v-if="form.dictValue == 'noPayShow'">
          <el-image 
            style="width: 100px; height: 200px"
            :src="require('@/assets/img/dict/noPayShow.png')" 
            :preview-src-list="[require('@/assets/img/dict/noPayShow.png')]">
          </el-image>
        </el-form-item>
        <el-form-item label="作用范围:" prop="level" label-width="100px">
          <el-radio-group v-model="form.level">
            <el-radio label="1">当前账号</el-radio>
            <el-radio label="2">当前账号及下级</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { agentDictList , agentList , agentDictSave , agentDictUpdate , agentDictDel} from "@/api/api";
export default {
  name: "NoDisplayPorduct",
  data() {
    return {
      loading:false,
      tableData:[],
      title:'',
      dialog:false,
      form:{
        id:undefined,
        userId:undefined,
        dictValue:undefined
      },
      rules:{
        userId:[
          { required: true, message: "请选择代理商", trigger: "blur" }
        ],
        dictValue:[
          { required: true, message: "请选择免显类型", trigger: "blur" }
        ],
        level:[
          { required: true, message: "请选择作用范围", trigger: "blur" }
        ],
      },
      agentData:[],
      keyword:'',
      dictValue:''  
    };
  },
  methods:{
    initData(){
      let key = "noDisplayProduct";
      agentDictList({key,keyword:this.keyword,dictValue:this.dictValue}).then(res=>{
        this.tableData = res.data.data
      })
    },
    search(){
      this.initData()
    },
    resetForm(){
      this.keyword = ''
      this.dictValue = ''
      this.initData()
    },
    submitForm(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!!this.form.id) {
            agentDictUpdate(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }else{
            this.form.dictKey = 'noDisplayProduct'
            agentDictSave(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }
        }
      })
    },
    selectAgentList() {
      agentList().then(res => {
        this.agentData = res.data.data;
      });
    },
    adds(){
      this.dialog = true
      this.title = "新增免显设置"
      this.form={level:'1'}
    },
    edit(row){
      this.dialog = true
      this.title = "修改免显设置"
      let form = {
        id:row.id,
        userId : row.userId,
        dictValue : row.dictValue,
        level : row.level
      }
      this.form = form
    },
    //删除免显
    del(row){
      let id = row.id
      this.$confirm("此操作将删除此免显设置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
			}).then(() => {
        agentDictDel({id}).then(res=>{
          this.$notify({
            title: '成功',
            message: '免显删除成功',
            type: 'success'
          });
          this.initData();
        })
      })
    }
  },
  created() {
    this.initData()
    this.selectAgentList()
  },
};
</script>